<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
                <el-button type="primary" @click="handleEdit(null, 'add')">新增标签</el-button>
            </el-row>
            <br/>
          <el-table
            :data="tableData"
            style="width: 100%"
            v-loading="loading">
            <el-table-column
              label="标签名"
              prop="name">
            </el-table-column>
            <el-table-column
              label="类型"
              :formatter="typeFormatter">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.row,'edit')">
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDeleteAlert( scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>



            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close" loa>
                <el-form :model="goods_tag">
                    <el-form-item label="标签名" label-width="100px">
                        <el-input v-model="goods_tag.name" auto-complete="off"  maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                  <el-form-item label="类型" label-width="100px">
                    <el-select v-model="goods_tag.type" placeholder="类型" style="width:100%;">
                      <el-option
                        key="1"
                        label="属性"
                        value="1">
                      </el-option>
                      <el-option
                        key="2"
                        label="规格"
                        value="2">
                      </el-option>
                      <el-option
                        key="3"
                        label="配料"
                        value="3">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="排序" label-width="100px">
                    <el-input-number :min="1" :max="1000" :step=1 v-model="goods_tag.showSort"  auto-complete="off"></el-input-number>
                    <el-alert
                      title="数字越大，排在前面"
                      type="success">
                    </el-alert>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                goods_tag:{
                    id:0,
                    name:"",
                    type:"1",
                    showSort:100,
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增菜品标签",
                    close:false,
                },
              tableData: [],
              defaultProps: {
                children: 'children',
                label: 'name'
              }
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/goods_tag', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.goods_tags;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            handleEdit(row,action) {
              if(action == "edit"){
                this.dialog.title = "修改菜品标签";
                this.goods_tag.id = row.id;
                this.goods_tag.name = row.name;
                this.goods_tag.type = ""+row.type;
                this.goods_tag.showSort = row.showSort;
                this.dialog.dialogFormVisible = true;
              }else if(action == "add"){
                this.dialog.title = "新增菜品标签";
                this.goods_tag.id = 0;
                this.goods_tag.name = "";
                this.goods_tag.type = "1";

                this.goods_tag.showSort = 100;
                this.dialog.dialogFormVisible = true;
              }
            },
            typeFormatter(row){
                if(row.type == 1){
                   return "属性";
                }else if(row.type == 2){
                  return "规格";
                }else if(row.type == 3){
                  return "配料";
                }

            },
            handleSave() {
              if(this.goods_tag.name == ''){
                this.$message({
                  message: "名字不能为空",
                  type: 'warning'
                });
                return;
              }
              this.loading = true;
              var that = this;
              that.goods_tag.showSort = parseInt(that.goods_tag.showSort);
              that.$api.post('/store/goods_tag', that.goods_tag, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: that.dialog.title+'成功',
                      type: 'success'
                    });
                    this.dialog.dialogFormVisible = false;
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }

              });

              this.loading = false;
            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该菜品标签, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
          handleDelete(row) {
            this.loading = true;
            var that = this;
            that.$api.delete('/store/goods_tag/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                    this.loading = false;
                  }
              } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                this.loading = false;
              }

            });
          },


        },
    }
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/GoodsTag.vue